module.exports = __webpack_public_path__ + "img/link-recruta.cd480960.svg";